module.exports = __webpack_public_path__ + "static/checkbox-label-dont-56b620accfc8dc6e33f48828e78b8e66.png";